import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { PrimaryButton } from "components/Buttons";
import { ProfileForm } from "components/Profile";
import { Link } from "components/Links";
import { useLinks } from "hooks";

/**
 * ProfileAddButton
 *
 * @param {Boolean} isModal
 */
const ProfileAddButton = ({ isModal, ...props }) => {
  const [showForm, setShowForm] = useState(false);
  const links = useLinks();

  if (isModal) {
    return (
      <>
        <PrimaryButton onClick={() => setShowForm(true)}>
          <FormattedMessage id={`Missions.ProfileAddButton`} />
        </PrimaryButton>
        <ProfileForm show={showForm} onClose={() => setShowForm(false)} isModal {...props} />
      </>
    );
  }

  return (
    <Link to={links.mission_create} routerEnabled>
      <PrimaryButton href={links.mission_create}>
        <FormattedMessage id={`Missions.ProfileAddButton`} />
      </PrimaryButton>
    </Link>
  );
};

ProfileAddButton.propTypes = {
  isModal: PropTypes.bool,
};

export default ProfileAddButton;
